/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Constants } from '@pwc/pwc-deals-web-common';
import PropTypes from 'prop-types';
import { EMPTY_DATA_MARKER } from '../../../../common/engine/utilities/constants';
import { isLastNPeriodLabel } from '../../../../common/services/textService';
import AdjustmentControlsColumn from './AdjustmentControlsColumn';
import FinancialValue from './FinancialValue';

const ReportedFinancials = ({
  testId,
  rowText,
  financials,
  timePeriods,
  className,
  emptyDataMarker = EMPTY_DATA_MARKER,
  documentCode,
  isPublishMode,
}) => {
  const isNwcTable = documentCode === Constants.NET_WORKING_CAPITAL;

  return (
    <tr
      role="row"
      className={`reported-financials ${className}`}
      data-testid={testId}
    >
      <th role="rowheader" scope="row" className="row-description">
        {rowText}
      </th>

      {timePeriods.map((timePeriodInput, index) => {
        const timePeriod = timePeriodInput.toString();
        const isLastNPeriod = isLastNPeriodLabel(timePeriod);
        const showColumnHighlight = isNwcTable && isLastNPeriod;

        return (
          <FinancialValue
            text={financials[timePeriod]}
            key={`reportedFinancialsColumnValue-${timePeriod}-${index}`}
            emptyDataMarker={emptyDataMarker}
            showColumnHighlight={showColumnHighlight}
          />
        );
      })}

      {!isPublishMode && <AdjustmentControlsColumn />}
    </tr>
  );
};

export default ReportedFinancials;

ReportedFinancials.propTypes = {
  testId: PropTypes.string,
  rowText: PropTypes.string.isRequired,
  financials: PropTypes.shape({}).isRequired,
  timePeriods: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  className: PropTypes.string,
  emptyDataMarker: PropTypes.string,
  documentCode: PropTypes.string,
  isPublishMode: PropTypes.bool,
};

ReportedFinancials.defaultProps = {
  testId: 'reported-financials',
  className: '',
  emptyDataMarker: EMPTY_DATA_MARKER,
  documentCode: '',
  isPublishMode: false,
};
